export default __webpack_public_path__ + "static/media/432.2bf6a72e.jpg";